(() => {
  if (window.ovelraDrawerSubmitBound) return;
  window.ovelraDrawerSubmitBound = true;
  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.closest('[data-ov-product]')) return;
    const button = form.querySelector('[data-ov-buy]');
    const drawer = document.querySelector('cart-drawer');
    if (!button || !drawer || typeof drawer.renderContents !== 'function') return;
    event.preventDefault();
    if (form.dataset.cartPending === 'true') return;
    form.dataset.cartPending = 'true';
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    let error = form.querySelector('[data-ov-cart-error]');
    if (!error) {
      error = document.createElement('p');
      error.dataset.ovCartError = '';
      error.setAttribute('role', 'alert');
      button.insertAdjacentElement('afterend', error);
    }
    error.hidden = true;
    let added = false;
    try {
      const body = new FormData(form);
      body.delete('return_to');
      body.set('sections', drawer.getSectionsToRender().map(section => section.id).join(','));
      body.set('sections_url', location.pathname);
      drawer.setActiveElement(button);
      const response = await fetch(window.routes?.cart_add_url || (window.Shopify?.routes?.root || '/') + 'cart/add.js', {
        method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body
      });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || data.message || window.cartStrings?.error);
      added = true;
      if (!data.sections || !data.sections['cart-drawer']) throw new Error('render');
      drawer.classList.remove('is-empty');
      drawer.renderContents(data);
    } catch (failure) {
      if (added) {
        location.assign(window.routes?.cart_url || (window.Shopify?.routes?.root || '/') + 'cart');
        return;
      }
      error.textContent = failure.message || window.cartStrings?.error;
      error.hidden = false;
    } finally {
      delete form.dataset.cartPending;
      const variant = form.closest('[data-ov-product]').querySelector('[data-ov-variant]');
      const option = variant?.selectedOptions?.[0];
      button.disabled = option ? option.dataset.available === 'false' : false;
      button.removeAttribute('aria-busy');
    }
  });
})();